// Port of SuiteModel/ManuscriptPositions.swift: where each scene starts in the book, as a fraction of the manuscript's
// words — one definition for the beat board, the outliner's Position column and the structure check.

/** How far a beat's first scene may sit from the sheet's target before it's worth a look. */
export const FAR_FROM_TARGET = 0.15;
/** Below this many words the book is too short for positions to mean much. */
export const POSITION_MINIMUM_WORDS = 5000;

/** `ManuscriptPositions.starts`: each count's start, the words before it over the total (0 for an empty book). */
export function manuscriptStarts(words: readonly number[]): number[] {
  const total = Math.max(1, words.reduce((a, b) => a + b, 0));
  let running = 0;
  return words.map((w) => {
    const start = running / total;
    running += w;
    return start;
  });
}

/** `ManuscriptPositions.isFar`. */
export const isFarFromTarget = (start: number, target: number, totalWords: number) =>
  totalWords >= POSITION_MINIMUM_WORDS && Math.abs(start - target) > FAR_FROM_TARGET;
